// Auto rate-type escalation (Booqable-style) — shared by every screen that
// prices a rental so a customer never sees a different number in two
// places for the same booking. Pure functions of (item, numDays); item
// only needs price_day/price_week/price_month (weekly_threshold and
// monthly_threshold default to 5 and 21 if absent — see the roadmap doc
// for why those defaults are hardcoded rather than truly per-product).
//
// No backend equivalent yet: the server currently trusts whatever
// total_price a client sends rather than recomputing it from these same
// rules. See docs/IVISION-ROADMAP-POST-SESSION43.md for that gap.

export function getAutoRateType(item, numDays) {
  if (!numDays) return 'day';
  const weekThreshold  = Number(item.weekly_threshold  || 5);
  const monthThreshold = Number(item.monthly_threshold || 21);
  if (item.price_month > 0 && numDays >= monthThreshold) return 'month';
  if (item.price_week  > 0 && numDays >= weekThreshold)  return 'week';
  return 'day';
}

export function getAutoPrice(item, rateType, numDays, discount = 0) {
  const base = rateType === 'hour'  ? Number(item.price_hour||0)
             : rateType === 'week'  ? Number(item.price_week||0)
             : rateType === 'month' ? Number(item.price_month||0)
             :                        Number(item.price_day||0);
  return discount ? Math.round(base * (1 - discount/100) * 100) / 100 : base;
}

export function getLineTotal(item, rateType, unitPrice, qty, numDays) {
  const q = parseInt(qty)||1;
  const p = parseFloat(unitPrice)||0;
  const d = numDays || 1;
  if (rateType === 'hour')  return p * d * q;
  if (rateType === 'day')   return p * d * q;
  if (rateType === 'week')  return p * Math.ceil(d / 7)  * q;
  if (rateType === 'month') return p * Math.ceil(d / 30) * q;
  return p * q;
}
